import styled from "styled-components";

export default function Footer() {
    return (
        <Container>
            <Top>
                <Brand>
                    <h2>SPC Escola</h2>
                    <p>Capacitando o futuro com conhecimento e inovação.</p>
                </Brand>

                <Links>
                    <h3>Links úteis</h3>
                    <ul>
                        <li><a href="#sobre">Sobre nós</a></li>
                        <li><a href="#cursos">Eventos</a></li>
                        <li><a href="#contato">Contato</a></li>
                        <li><a href="#politica">Política de Privacidade</a></li>
                    </ul>
                </Links>

                <Contato>
                    <h3>Contato</h3>
                    <p>(21) 4141-4115</p>
                    <p>atendimento@spcrio.com</p>
                </Contato>
            </Top>

            <Bottom>
                <p>© {new Date().getFullYear()} SPC Escola. Todos os direitos reservados.</p>
            </Bottom>
        </Container>
    );
}

const Container = styled.footer`
    background-color: #264b91;
    padding: 40px 20px 20px;
    color: #FFFFFF;
    font-family: 'Poppins', sans-serif;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
`;

const Top = styled.section`
    width: 100%;
    display: flex;
    justify-content: space-around;
    align-items: flex-start;
    flex-wrap: wrap;
    gap: 40px;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    box-sizing: border-box;

    @media (max-width: 768px) {
        flex-direction: column;
        align-items: center;
        text-align: center;
        gap: 30px;
    }
`;

const Brand = styled.div`
    max-width: 300px;

    h2 {
        font-size: 28px;
        font-weight: bold;
        color: #fbb040;
        margin-bottom: 0.5rem;
    }

    p {
        font-size: 14px;
        color: #f1f1f1;
    }

    @media (max-width: 768px) {
        h2 {
            font-size: 24px;
        }
        p {
            font-size: 13px;
        }
    }
`;

const Links = styled.div`
    h3 {
        margin-bottom: 0.8rem;
        font-size: 1.1rem;
        border-bottom: 2px solid #fbb040;
        display: inline-block;
        padding-bottom: 0.3rem;
    }

    ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    li {
        margin-bottom: 0.5rem;
    }

    a {
        color: #FFFFFF;
        text-decoration: none;
        font-size: 14px;
        transition: color 0.3s;
    }

    a:hover {
        color: #fbb040;
    }

    @media (max-width: 768px) {
        h3 {
            font-size: 1rem;
        }
        a {
            font-size: 13px;
        }
    }
`;

const Contato = styled.div`
    h3 {
        margin-bottom: 0.8rem;
        font-size: 1.1rem;
        border-bottom: 2px solid #fbb040;
        display: inline-block;
        padding-bottom: 0.3rem;
    }

    p {
        margin: 0.3rem 0;
        font-size: 14px;
    }

    @media (max-width: 768px) {
        h3 {
            font-size: 1rem;
        }
        p {
            font-size: 13px;
        }
    }
`;

const Bottom = styled.section`
    text-align: center;
    padding-top: 15px;
    font-size: 0.9rem;
    color: #ccc;

    @media (max-width: 600px) {
        font-size: 0.8rem;
    }
`;
